import isEqual from 'lodash/isEqual';
import differenceWith from 'lodash/differenceWith';

export const getShallowObjectsArrayDifference = (initialData, changedData) => {
  const changedDifference = differenceWith(changedData, initialData, isEqual);
  const initialDifference = differenceWith(initialData, changedData, isEqual);

  return changedDifference.map((data, index) => {
    const changedKeys = Object.keys(initialDifference[index]).filter(key => {
      return typeof data[key] === 'object' || data[key] !== initialDifference[index][key];
    });

    return changedKeys.reduce((prev, current) => {
      return {
        ...prev,
        [current]: data[current],
      };
    }, {});
  });
};
